export default {
  remittanceAdvices(currentState, value) {
    const state = currentState;
    state.remittanceAdvices = Object.assign([], value);
  },
};
